<script setup lang="ts">

</script>

<template>
  <div class="wad4-spinner">
    <div class="wad4-spinner__indicator"></div>
  </div>
</template>

<style lang="scss">
.wad4-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  &__indicator {
    width: 30px;
    height: 30px;
    border: 4px solid rgba(196, 196, 196, 0.1);
    border-top: 4px solid $wad4-c-background-bg-brand-solid;
    border-radius: 50%;
    animation: wad4-spin 1s linear infinite;
  }
}

@keyframes wad4-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
